import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/flatpickr.min.css'

export class DatePicker {
  constructor() {
    const targets = document.querySelectorAll('.js-datepicker')
    if (targets.length === 0) return

    const baseOptions = {
      locale: Japanese,
      minDate: 'today',
      formatDate: (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const w = ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
        return `${y}年${m}月${d}日（${w}）`
      },
    }

    Array.from(targets).forEach((target) => {
      const options = { ...baseOptions }
      const allowedRaw = target.dataset.datepickerAllowed

      if (allowedRaw) {
        try {
          const allowedDates = JSON.parse(allowedRaw)
          if (Array.isArray(allowedDates) && allowedDates.length > 0) {
            options.enable = allowedDates
          }
        } catch {
          // Ignore invalid values and keep default datepicker behavior.
        }
      }

      flatpickr(target, options)
    })
  }
}
